module.exports = __webpack_public_path__ + "assets/img/btn-back-83252a65.png";